export default "__VITE_ASSET__3f14d999__"